export default __webpack_public_path__ + "static/media/112.b7beeeda.jpg";